export default {
  ACCOUNT: 'ACCOUNT',
  AGREEMENTS: 'AGREEMENTS',
  CONTACT: 'CONTACT',
  EMBED_CODE: 'EMBED_CODE',
  DEVICE: 'DEVICE',
  PIN: 'PIN',
};
